import { useRef, useState } from 'react';
import ButtonText from '../../components/button/button-text/ButtonText';
import { formatMoneyKr, formatMoneyKroner } from '../../utils';
import { SectionTitle } from '../../components/typography/Heading';
import Image from '../../components/image/Image';
import { useToppKommuner } from './topp3-kommuner-hook';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import Chevron from '../../components/chevron/Chevron';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import styles from './tva-topp3-kommuner.module.less';

const ToppListe = ({ kommuner, max }) =>
    kommuner.slice(0, max).map((kommune, idx) => {
        const url = `/bosser/${encodeURIComponent(kommune.fylke)}/${encodeURIComponent(kommune.navn)}`;

        return (
            <li key={kommune.navn}>
                <TrackEventLink
                    to={url}
                    className={styles.listElement}
                    aria-label={`${kommune.navn} – ${formatMoneyKroner(kommune.gjennomsnitt, true)} per innbygger`}
                >
                    <div className={styles.plassNummer}>{idx + 1}</div>
                    <div className={styles.kommune}>
                        <div className={styles.kommunenavn}>{kommune.navn}</div>
                        <div className={styles.kommuneResultat}>
                            <div>{formatMoneyKr(kommune.gjennomsnitt, true)} per innbygger</div>
                            <div>
                                <Image
                                    src={'campaign/tva2021/bosse.svg'}
                                    alt={''}
                                    async
                                    aria-hidden
                                    loading="lazy"
                                    className={styles.bosseikon}
                                />
                                <span>{kommune.antallBosser} bøsser</span>
                            </div>
                        </div>
                    </div>
                </TrackEventLink>
            </li>
        );
    });
export const TvaToppKommuner = () => {
    const { isLoading, toppKommuner } = useToppKommuner();

    const [max, setMax] = useState(3);
    const container = useRef();

    const scrollToTop = () => {
        container?.current?.scrollIntoView({ block: 'start' });
    };

    return (
        <section className={styles.campaignsContainer} ref={container}>
            <SectionTitle tag="h2" className={styles.subTitle}>
                Topp {max} kommuner
            </SectionTitle>
            <div className={styles.campaignCardContent}>
                <div className={styles.campaignIllustrationWrapper}>
                    <Image
                        className={styles.campaignIllustration}
                        alt={'To blide bøssebærere'}
                        src={'campaign/tva2025/tva-2025-gruppe.svg'}
                    />
                </div>
                <div className={styles.listAndExpand}>
                    <ul className={styles.listContainer}>
                        {isLoading ? (
                            <li>
                                <LoaderBar />
                            </li>
                        ) : (
                            <ToppListe kommuner={toppKommuner} max={max} />
                        )}
                    </ul>
                    {max === 3 && (
                        <ButtonText onClick={() => setMax(100)}>
                            Se topp 100 kommuner
                            <Chevron className={styles.arrow} />
                        </ButtonText>
                    )}
                    {max === 100 && (
                        <ButtonText
                            onClick={() => {
                                setMax(3);
                                scrollToTop();
                            }}
                        >
                            Se topp 3 kommuner
                            <Chevron className={styles.arrow} direction={'up'} />
                        </ButtonText>
                    )}
                </div>
            </div>
        </section>
    );
};

export default TvaToppKommuner;
